
import { Component, Vue } from 'vue-property-decorator';
import ExpandIcon from "@/components/utils/ExpandIcon.vue";

@Component({
    components:{
        ExpandIcon
    }
})
export default class FactumAppealBookCertificateAppLeaveGrantedPg extends Vue {

    showFactumInfo = true;
    showRespondentFactumInfo = false;    
    showRespondentTranscriptInfo = false;
    transcriptExtractBookHelpText = '<div>If a witness spoke at your original trial or hearing, and you mentioned this oral testimony in your Factum, you will need to complete a Transcript Extract Book.</div>';


    public showFactum(show: boolean){
        if (show) {
            this.showFactumInfo = true;
            this.$emit('adjustHeights', 0, "20rem");
        } else {
            this.showFactumInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }
    }

    public showRespondentFactum(show: boolean){
        if (show) {
            this.showRespondentFactumInfo = true;
            this.$emit('adjustHeights', 1, "14rem");
        } else {
            this.showRespondentFactumInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    }

     public showRespondentTranscript(show: boolean){
        if (show) {
            this.showRespondentTranscriptInfo = true;
            this.$emit('adjustHeights', 2, "3rem");
        } else {
            this.showRespondentTranscriptInfo = false;
            this.$emit('adjustHeights', 2, "0");
        }
    }

}
